import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";


// *********************************** Manage User ***********************************************
export const getDonationList = async (data) => {
  return decryptData(
    await axios.get(
      `/getDonationList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addDonation = async (data) => {
    return decryptData(
      await axios.post(`/addDonation`, {
        reqData: encryptData({
          ...data,
          access_token: isLoggedIn(),
        }),
      })
    );
  };